/**
 * This file is generated from 'npm run build-svg'. Any changes should be made to the
 * template in .svgrrc.js or to the source SVG in src/icons/svg.
 **/
import React from "react";
export const SvgCheckThin: React.FC<React.SVGAttributes<SVGElement>> = (
    props
) => (
    <svg viewBox="0 0 14 14" fill="none" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.516 2.842a.578.578 0 01.168.799l-4.8 7.35a.577.577 0 01-.897.088l-3.6-3.675a.578.578 0 01.826-.808L6.31 9.758l4.407-6.749a.578.578 0 01.799-.167z"
            fill="currentColor"
        />
    </svg>
);
